import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinFocusEvent, mixinBlurEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/calendar/calendar';
import '@fa-switch-sharedservices/web-elements/components/date-picker/date-picker';
import '@fa-switch-sharedservices/web-elements/components/date-picker/date-range-picker';
import { FadvIconModule } from '@fa-switch-sharedservices/ng-elements/fadv-icon';

class FadvDatePickerComponent extends mixinFocusEvent(mixinBlurEvent(mixinFormControl(FadvBaseComponent))) {
    constructor(el) {
        super(el);
    }
    ngAfterContentInit() {
        super.ngAfterContentInit();
        this.registerSubscription(this.blurred, () => this.onTouched());
        this.registerFormValueChangeHandler((value) => (this.elementRef.nativeElement.value = value ? new Date(value) : undefined));
    }
    ngOnChanges(changes) {
        var _a;
        const datePicker = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement;
        if (!datePicker)
            return;
        Object.keys(changes).forEach((key) => {
            const value = changes[key].currentValue;
            switch (key) {
                case 'date':
                case 'value':
                case 'min':
                case 'max': {
                    datePicker[key === 'value' ? 'date' : key] = value ? new Date(value) : undefined;
                    break;
                }
                default:
                    datePicker[key] = value;
                    break;
            }
        });
        this.onChanges.emit(changes);
    }
    handleChange(e) {
        const event = e;
        this.reportChange(event.detail.date);
    }
}
FadvDatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDatePickerComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvDatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvDatePickerComponent, selector: "fadv-date-picker", inputs: { value: "value", disabled: "disabled", name: "name", label: "label", readonly: "readonly", required: "required", helpText: "helpText", clearable: "clearable", valid: "valid", invalid: "invalid", autofocus: "autofocus", min: "min", max: "max", variant: "variant", pill: "pill", floating: "floating", datePattern: "datePattern" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred" }, host: { listeners: { "fadv-calendar-date-change": "handleChange($event)" } }, providers: [createFormControlProvider(FadvDatePickerComponent)], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "readonly", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "required", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "clearable", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "valid", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "autofocus", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "min", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "max", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "floating", void 0);
__decorate([
    Forward()
], FadvDatePickerComponent.prototype, "datePattern", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDatePickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-date-picker',
                    template: '',
                    providers: [createFormControlProvider(FadvDatePickerComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { name: [{
                type: Input
            }], label: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], helpText: [{
                type: Input
            }], clearable: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalid: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], variant: [{
                type: Input
            }], pill: [{
                type: Input
            }], floating: [{
                type: Input
            }], datePattern: [{
                type: Input
            }], handleChange: [{
                type: HostListener,
                args: ['fadv-calendar-date-change', ['$event']]
            }] } });

class FadvDateRangePickerComponent extends mixinFocusEvent(mixinBlurEvent(mixinFormControl(FadvBaseComponent))) {
    constructor(el) {
        super(el);
    }
    ngAfterContentInit() {
        this.registerSubscription(this.blurred, () => this.onTouched());
        this.registerFormValueChangeHandler((value) => (this.elementRef.nativeElement.value = value));
    }
    ngOnChanges(changes) {
        const datePicker = this.elementRef.nativeElement;
        if (!datePicker)
            return;
        Object.keys(changes).forEach((key) => {
            const value = changes[key].currentValue;
            switch (key) {
                case 'value':
                    if (!value) {
                        datePicker[key] = undefined;
                    }
                    else if (Array.isArray(value)) {
                        datePicker[key] = value;
                    }
                    else if (typeof value === 'string') {
                        const range = value.split(',');
                        const start = new Date(range[0]);
                        const end = new Date(range[1]);
                        datePicker[key] = [start, end];
                    }
                    break;
                case 'min':
                case 'max':
                    datePicker[key] = value ? new Date(value) : undefined;
                    break;
                default:
                    datePicker[key] = value;
                    break;
            }
        });
        this.onChanges.emit(changes);
    }
    handleChange(e) {
        const { detail: { rangeStart, rangeEnd }, } = e;
        this.emitChanges([rangeStart, rangeEnd]);
    }
    emitChanges(value) {
        const [rangeStart, rangeEnd] = value || [undefined, undefined];
        this.elementRef.nativeElement.rangeStart = rangeStart;
        this.elementRef.nativeElement.rangeEnd = rangeEnd;
        this.reportChange(value);
    }
}
FadvDateRangePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDateRangePickerComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvDateRangePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvDateRangePickerComponent, selector: "fadv-date-range-picker", inputs: { value: "value", disabled: "disabled", name: "name", label: "label", readonly: "readonly", required: "required", helpText: "helpText", clearable: "clearable", valid: "valid", invalid: "invalid", autofocus: "autofocus", min: "min", max: "max", variant: "variant", pill: "pill", floating: "floating", datePattern: "datePattern" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred" }, host: { listeners: { "fadv-calendar-range-change": "handleChange($event)" } }, providers: [createFormControlProvider(FadvDateRangePickerComponent)], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "readonly", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "required", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "clearable", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "valid", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "autofocus", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "min", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "max", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "floating", void 0);
__decorate([
    Forward()
], FadvDateRangePickerComponent.prototype, "datePattern", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDateRangePickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-date-range-picker',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvDateRangePickerComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { name: [{
                type: Input
            }], label: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], helpText: [{
                type: Input
            }], clearable: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalid: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], variant: [{
                type: Input
            }], pill: [{
                type: Input
            }], floating: [{
                type: Input
            }], datePattern: [{
                type: Input
            }], handleChange: [{
                type: HostListener,
                args: ['fadv-calendar-range-change', ['$event']]
            }] } });

class FadvDatePickerModule {
}
FadvDatePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvDatePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvDatePickerModule, declarations: [FadvDatePickerComponent, FadvDateRangePickerComponent], imports: [FadvCommonModule, FadvIconModule], exports: [FadvDatePickerComponent, FadvDateRangePickerComponent] });
FadvDatePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDatePickerModule, imports: [FadvCommonModule, FadvIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvDatePickerComponent, FadvDateRangePickerComponent],
                    imports: [FadvCommonModule, FadvIconModule],
                    exports: [FadvDatePickerComponent, FadvDateRangePickerComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvDatePickerComponent, FadvDatePickerModule, FadvDateRangePickerComponent };
